import script from "./UserActionLogsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserActionLogsPage.vue?vue&type=script&setup=true&lang=js"

import "./UserActionLogsPage.vue?vue&type=style&index=0&id=44b77b9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b77b9b"]])

export default __exports__